/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIConnection,
    AIConnectionFromJSON,
    AIConnectionFromJSONTyped,
    AIConnectionToJSON,
    CloudConnection,
    CloudConnectionFromJSON,
    CloudConnectionFromJSONTyped,
    CloudConnectionToJSON,
    ElementsUserDetail,
    ElementsUserDetailFromJSON,
    ElementsUserDetailFromJSONTyped,
    ElementsUserDetailToJSON,
    ElementsVersion,
    ElementsVersionFromJSON,
    ElementsVersionFromJSONTyped,
    ElementsVersionToJSON,
    Event,
    EventFromJSON,
    EventFromJSONTyped,
    EventToJSON,
    License,
    LicenseFromJSON,
    LicenseFromJSONTyped,
    LicenseToJSON,
    MediaRootPermission,
    MediaRootPermissionFromJSON,
    MediaRootPermissionFromJSONTyped,
    MediaRootPermissionToJSON,
    Parameters,
    ParametersFromJSON,
    ParametersFromJSONTyped,
    ParametersToJSON,
    PublicParameters,
    PublicParametersFromJSON,
    PublicParametersFromJSONTyped,
    PublicParametersToJSON,
    SAMLProviderMini,
    SAMLProviderMiniFromJSON,
    SAMLProviderMiniFromJSONTyped,
    SAMLProviderMiniToJSON,
    StorageNode,
    StorageNodeFromJSON,
    StorageNodeFromJSONTyped,
    StorageNodeToJSON,
    TaskType,
    TaskTypeFromJSON,
    TaskTypeFromJSONTyped,
    TaskTypeToJSON,
    TasksSummary,
    TasksSummaryFromJSON,
    TasksSummaryFromJSONTyped,
    TasksSummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface BootstrapData
 */
export interface BootstrapData {
    /**
     * 
     * @type {StorageNode}
     * @memberof BootstrapData
     */
    currentNode: StorageNode;
    /**
     * 
     * @type {License}
     * @memberof BootstrapData
     */
    license: License;
    /**
     * 
     * @type {Parameters}
     * @memberof BootstrapData
     */
    parameterValues: Parameters;
    /**
     * 
     * @type {PublicParameters}
     * @memberof BootstrapData
     */
    publicParameters: PublicParameters;
    /**
     * 
     * @type {Array<string>}
     * @memberof BootstrapData
     */
    knownUsernames: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BootstrapData
     */
    knownEmails: Array<string>;
    /**
     * 
     * @type {ElementsUserDetail}
     * @memberof BootstrapData
     */
    identityValue?: ElementsUserDetail;
    /**
     * 
     * @type {boolean}
     * @memberof BootstrapData
     */
    impersonationActive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BootstrapData
     */
    oneTimeAccessTokenActive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BootstrapData
     */
    debug: boolean;
    /**
     * 
     * @type {ElementsVersion}
     * @memberof BootstrapData
     */
    version: ElementsVersion;
    /**
     * 
     * @type {string}
     * @memberof BootstrapData
     */
    clientOs: string;
    /**
     * 
     * @type {string}
     * @memberof BootstrapData
     */
    sessionId: string;
    /**
     * 
     * @type {Array<CloudConnection>}
     * @memberof BootstrapData
     */
    cloudConnections: Array<CloudConnection>;
    /**
     * 
     * @type {Array<AIConnection>}
     * @memberof BootstrapData
     */
    aiConnections: Array<AIConnection>;
    /**
     * 
     * @type {Array<Event>}
     * @memberof BootstrapData
     */
    events: Array<Event>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof BootstrapData
     */
    sentryConfig: { [key: string]: string | undefined; };
    /**
     * 
     * @type {boolean}
     * @memberof BootstrapData
     */
    hasWanNetworks: boolean;
    /**
     * 
     * @type {{ [key: string]: TaskType | undefined; }}
     * @memberof BootstrapData
     */
    taskMeta: { [key: string]: TaskType | undefined; };
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof BootstrapData
     */
    scannerMetadataSchema: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {Array<MediaRootPermission>}
     * @memberof BootstrapData
     */
    mediaRootPermissions: Array<MediaRootPermission>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof BootstrapData
     */
    sharedStorageValues: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof BootstrapData
     */
    userStorageValues: { [key: string]: string | undefined; };
    /**
     * 
     * @type {Array<SAMLProviderMini>}
     * @memberof BootstrapData
     */
    samlProviders: Array<SAMLProviderMini>;
    /**
     * 
     * @type {SAMLProviderMini}
     * @memberof BootstrapData
     */
    activeSamlProvider?: SAMLProviderMini;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof BootstrapData
     */
    settings: { [key: string]: string | undefined; };
    /**
     * 
     * @type {TasksSummary}
     * @memberof BootstrapData
     */
    tasksSummary?: TasksSummary;
    /**
     * 
     * @type {boolean}
     * @memberof BootstrapData
     */
    kibanaEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof BootstrapData
     */
    systemName: string;
}

export function BootstrapDataFromJSON(json: any): BootstrapData {
    return BootstrapDataFromJSONTyped(json, false);
}

export function BootstrapDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BootstrapData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currentNode': StorageNodeFromJSON(json['current_node']),
        'license': LicenseFromJSON(json['license']),
        'parameterValues': ParametersFromJSON(json['parameter_values']),
        'publicParameters': PublicParametersFromJSON(json['public_parameters']),
        'knownUsernames': json['known_usernames'],
        'knownEmails': json['known_emails'],
        'identityValue': !exists(json, 'identity_value') ? undefined : ElementsUserDetailFromJSON(json['identity_value']),
        'impersonationActive': json['impersonation_active'],
        'oneTimeAccessTokenActive': json['one_time_access_token_active'],
        'debug': json['debug'],
        'version': ElementsVersionFromJSON(json['version']),
        'clientOs': json['client_os'],
        'sessionId': json['session_id'],
        'cloudConnections': ((json['cloud_connections'] as Array<any>).map(CloudConnectionFromJSON)),
        'aiConnections': ((json['ai_connections'] as Array<any>).map(AIConnectionFromJSON)),
        'events': ((json['events'] as Array<any>).map(EventFromJSON)),
        'sentryConfig': json['sentry_config'],
        'hasWanNetworks': json['has_wan_networks'],
        'taskMeta': (mapValues(json['task_meta'], TaskTypeFromJSON)),
        'scannerMetadataSchema': json['scanner_metadata_schema'],
        'mediaRootPermissions': ((json['media_root_permissions'] as Array<any>).map(MediaRootPermissionFromJSON)),
        'sharedStorageValues': json['shared_storage_values'],
        'userStorageValues': json['user_storage_values'],
        'samlProviders': ((json['saml_providers'] as Array<any>).map(SAMLProviderMiniFromJSON)),
        'activeSamlProvider': !exists(json, 'active_saml_provider') ? undefined : SAMLProviderMiniFromJSON(json['active_saml_provider']),
        'settings': json['settings'],
        'tasksSummary': !exists(json, 'tasks_summary') ? undefined : TasksSummaryFromJSON(json['tasks_summary']),
        'kibanaEnabled': json['kibana_enabled'],
        'systemName': json['system_name'],
    };
}

export function BootstrapDataToJSON(value?: BootstrapData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'current_node': StorageNodeToJSON(value.currentNode),
        'license': LicenseToJSON(value.license),
        'parameter_values': ParametersToJSON(value.parameterValues),
        'public_parameters': PublicParametersToJSON(value.publicParameters),
        'known_usernames': value.knownUsernames,
        'known_emails': value.knownEmails,
        'identity_value': ElementsUserDetailToJSON(value.identityValue),
        'impersonation_active': value.impersonationActive,
        'one_time_access_token_active': value.oneTimeAccessTokenActive,
        'debug': value.debug,
        'version': ElementsVersionToJSON(value.version),
        'client_os': value.clientOs,
        'session_id': value.sessionId,
        'cloud_connections': ((value.cloudConnections as Array<any>).map(CloudConnectionToJSON)),
        'ai_connections': ((value.aiConnections as Array<any>).map(AIConnectionToJSON)),
        'events': ((value.events as Array<any>).map(EventToJSON)),
        'sentry_config': value.sentryConfig,
        'has_wan_networks': value.hasWanNetworks,
        'task_meta': (mapValues(value.taskMeta, TaskTypeToJSON)),
        'scanner_metadata_schema': value.scannerMetadataSchema,
        'media_root_permissions': ((value.mediaRootPermissions as Array<any>).map(MediaRootPermissionToJSON)),
        'shared_storage_values': value.sharedStorageValues,
        'user_storage_values': value.userStorageValues,
        'saml_providers': ((value.samlProviders as Array<any>).map(SAMLProviderMiniToJSON)),
        'active_saml_provider': SAMLProviderMiniToJSON(value.activeSamlProvider),
        'settings': value.settings,
        'tasks_summary': TasksSummaryToJSON(value.tasksSummary),
        'kibana_enabled': value.kibanaEnabled,
        'system_name': value.systemName,
    };
}


